
import React from 'react'
import './index.less'
console.log(React)
export default function BasicsImage(props) {
  const src = props.ifon.imageIfon.path

  return (<div className={`basicsImage ${props.selectItem ? props.selectItem.id === props.compIfon.id ? 'active' : '' : ''}`} style={{
    paddingTop: props.ifon.padding_top + 'px',
    paddingBottom: props.ifon.padding_bottom + 'px'
  }}>
    {src ? <div className='basicsImage_div2'>
      <img className='img' src={src} />
    </div> : <div className='basicsImage_div1'>
      <i className='div1_icon'><svg width='80' height='54' viewBox='0 0 28 28'><defs><linearGradient x1='50%' y1='99.707%' x2='50%' y2='5.583%' id='a'><stop stop-color='#999' offset='0%'></stop><stop stop-color='#737373' offset='100%'></stop></linearGradient></defs><path d='M19.5 6A2.5 2.5 0 0122 8.5v11a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 016 19.5v-11A2.5 2.5 0 018.5 6h11zm-2.657 8.156a1 1 0 00-1.347.006l-4.22 3.881a.5.5 0 01-.643.03l-2.731-2.087a.25.25 0 00-.402.199V19.5a1 1 0 001 1h11a1 1 0 001-1v-1.82a.5.5 0 00-.165-.371zM11 9.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z' fill='url(#a)' fill-rule='nonzero'></path></svg></i>
      <button onMouseDown={(e) => {
        e.stopPropagation()
      }} className='div1_button' onClick={(e) => {
        e.stopPropagation()
        props.hoistPopup && props.hoistPopup()
      }}>上传图片</button>
    </div>}
  </div>)
}
